module.exports = __webpack_public_path__ + "img/license_disk_engine_no.4515a39a.png";